import { FormFieldTypes } from "../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../components/finalForms/libs/data/ValidationTypes";
import { FileFormats } from "../../../components/finalForms/libs/data/fileFormatTypes";

const initState = {
    todoDocument: null
}

export const AddTodoDocumentConfig = {
    name: "Document Section",
    initialState: initState,
    section: [
        {
            sectionId: "documentSection",
            title: "Document Section",
            row: {},
            style: {
                sectionStyle: "col-lg-12 col-md-12",
            },
            wrapperTemplate: <div className="row"></div>,
            fields: [
                {
                    id: "todoDocument",
                    label: "",
                    Field_Name: "file",
                    fieldType: FormFieldTypes.FILE,
                    dataField: "todoDocument",
                    fieldSetting: {
                        placeholder: 'Select Todo Document',
                        allowMultipleFiles: false,
                        acceptedFileFormats: [
                            FileFormats.XLSX,
                        ],
                        minFileSizeInMB: 0,
                        maxFileSizeInMB: 3,
                    },
                    validation: [
                        { type: validationTypes.REQUIRE },
                        // { type: validationTypes.FILE },
                    ],
                    style: {
                        containerCss: "col-12 mb-1",
                    },
                },
            ]
        }
    ]
}